





























































// decoradores
import { Vue, Component, Prop, Emit } from "vue-property-decorator";
// validaciones
import { required } from "vuelidate/lib/validators";
// tipos
import {
  Ingreso,
  Ingresos,
} from "@/typings/store/plugins/easyFirestore/ingresos";
// api excel
import Excel from "exceljs";

interface Registro {
  // entrada: Date;
  // salida: Date;
  nombre: string;
  posicion: string;
  PERIODO_ARRENDAMIENTO: string;
  FECHA: string;
  FORMA_PAGO: string;
  TIPO_IGRESO: string;
  COD_CUENTA: string;
  N_DOCUMENTO: string; // N° de documento o factura
  MONTO_INGRESO: string;
  MONTO_ABONO: string;
  GLOSA: string;
  RUT_CLIENTE: string;
  NOMBRE_CLIENTE: string;
  N_CONTRATO: string;
  CENTRO_DE_COSTO: string;
  LOCAL: string;
  BANCO: string;
  FORMA_INGRESO: string;
  N_DOCUMENTO_BANCARIO: string;
  LOCAL_CONTRATO: string;

  PERIODO_LIBRO_SII: string;
  TIPO_DOCUMENTO_REFERENCIA: string;
  TIPO_DOCUMENTO: string;
  N_DOCUMENTO_REFERENCIA: string;
}

interface NombresIngresos {
  [nombre: string]: Ingreso;
}

// const date = (value: Date) => {
//   return value.toString() != "Invalid Date";
// };

@Component({
  validations: {
    archivo: { required },
  },
})
export default class CargarExcel extends Vue {
  @Prop() readonly ingresos!: Ingresos;

  archivo: Blob | null = null;
  cargando = false;
  clickCargar = false;

  despachos: Array<Ingreso> = [];
  mensajes: Array<string> = [];

  get nombresBancos(): NombresIngresos {
    const resultado: NombresIngresos = {};
    Object.values(this.ingresos).forEach((item) => {
      resultado[item.nombre] = Object.assign({}, item);
    });
    return resultado;
  }

  // get rfidPatentes(): RfidPatentes {
  //   const resultado: RfidPatentes = {};
  //   Object.values(this.rfids).forEach((item) => {
  //     resultado[item.patente] = Object.assign({}, item);
  //   });
  //   return resultado;
  // }

  get archivoError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.archivo.$dirty) return errors;
    if (!this.$v.archivo.required) errors.push("Requerido");
    return errors;
  }

  @Emit("carga-excel")
  onCargaExcel(): Array<Ingreso> {
    return this.despachos;
  }

  // valoresValidos(valores: Array<Excel.CellValue>): boolean {
  //   if (!valores[1] || !valores[2] ) {
  //     return false;
  //   }
  //   const nombre = valores[1] ;
  //   const posicion = valores[2];
  //   //return !!entrada && !!salida && date(entrada) && date(salida);
  //   return nombre && posicion
  // }

  async cargar(): Promise<void> {
    this.$v.$touch();
    if (this.$v.$invalid || !this.archivo) {
      return;
    }
    this.cargando = true;
    this.clickCargar = true;
    const workbook = new Excel.Workbook();
    const data = await this.archivo.arrayBuffer();
    await workbook.xlsx.load(data);
    // worksheet
    const worksheet = workbook.getWorksheet(1);
    //console.log("registros", worksheet.actualRowCount - 1);
    if (worksheet.actualRowCount - 1 > 500) {
      //console.log("registros mayores a 500");
      this.mensajes.push("error: cantidad de registros mayor a 500");
      this.cargando = false;
      return;
    }
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber != 1) {
        const valores = row.values as Array<Excel.CellValue>;
        if (valores[3] == "ejemplo") {
          console.log("error row", rowNumber);
          this.mensajes.push(
            "error: row " +
              rowNumber +
              " invalida, contiene campos vacios, fechas invalidas o la etiqueta prueba"
          );
          return;
        }
        const registro: Registro = {
          nombre: valores[1] as string,
          posicion: valores[2] as string,
          PERIODO_ARRENDAMIENTO: valores[3] as string,
          FECHA: valores[4] as string,
          FORMA_PAGO: valores[5] as string,
          TIPO_IGRESO: valores[6] as string,
          COD_CUENTA: valores[7] as string, // N° de documento o factura
          N_DOCUMENTO: valores[8] as string, // N° de documento o factura
          MONTO_INGRESO: valores[9] as string,
          MONTO_ABONO: valores[10] as string,
          GLOSA: valores[11] as string,
          RUT_CLIENTE: valores[12] as string,
          NOMBRE_CLIENTE: valores[13] as string,
          N_CONTRATO: valores[14] as string,
          CENTRO_DE_COSTO: valores[15] as string,
          LOCAL: valores[16] as string,
          BANCO: valores[17] as string,
          FORMA_INGRESO: valores[18] as string,
          N_DOCUMENTO_BANCARIO: valores[19] as string,
          LOCAL_CONTRATO: valores[20] as string,

          PERIODO_LIBRO_SII: valores[21] as string,
          TIPO_DOCUMENTO_REFERENCIA: valores[22] as string,
          TIPO_DOCUMENTO: valores[23] as string,
          N_DOCUMENTO_REFERENCIA: valores[24] as string,
        };
        // const banco = this.nombresBancos[registro.nombre];
        //  if (!banco) {
        //    console.log("error row", rowNumber);
        //    this.mensajes.push(
        //      "error: row " + rowNumber + " invalida, patente no registrada"
        //    );
        //    return;
        //  }
        const ingreso: Ingreso = {
          nombre: registro.nombre ?? "",
          posicion: registro.posicion ?? "",
          PERIODO_ARRENDAMIENTO: registro.PERIODO_ARRENDAMIENTO ?? "",
          FECHA: registro.FECHA ?? "",
          FORMA_PAGO: registro.FORMA_PAGO ?? "",
          TIPO_IGRESO: registro.TIPO_IGRESO ?? "",
          COD_CUENTA: registro.COD_CUENTA ?? "", // N° de documento o factura
          N_DOCUMENTO: registro.N_DOCUMENTO ?? "", // N° de documento o factura
          MONTO_INGRESO: registro.MONTO_INGRESO ?? "",
          MONTO_ABONO: registro.MONTO_ABONO ?? "",
          GLOSA: registro.GLOSA ?? "",
          RUT_CLIENTE: registro.RUT_CLIENTE ?? "",
          NOMBRE_CLIENTE: registro.NOMBRE_CLIENTE ?? "",
          N_CONTRATO: registro.N_CONTRATO ?? "",
          CENTRO_DE_COSTO: registro.CENTRO_DE_COSTO ?? "",
          LOCAL: registro.LOCAL ?? "",
          BANCO: registro.BANCO ?? "",
          FORMA_INGRESO: registro.FORMA_INGRESO ?? "",
          N_DOCUMENTO_BANCARIO: registro.N_DOCUMENTO_BANCARIO ?? "",
          LOCAL_CONTRATO: registro.LOCAL_CONTRATO ?? "",

          PERIODO_LIBRO_SII: registro.PERIODO_LIBRO_SII ?? "",
          TIPO_DOCUMENTO_REFERENCIA: registro.TIPO_DOCUMENTO_REFERENCIA ?? "",
          TIPO_DOCUMENTO: registro.TIPO_DOCUMENTO ?? "",
          N_DOCUMENTO_REFERENCIA: registro.N_DOCUMENTO_REFERENCIA ?? "",
        };

        this.despachos.push(ingreso);
      }
    });
    if (this.mensajes.length > 0) {
      this.mensajes.push("cargado con errores");
      this.mensajes.push("corregir excel y volver a intentar");
      this.cargando = false;
    } else {
      this.mensajes.push("cargado completo");
      this.mensajes.push(this.despachos.length + " ingresos cargados");
      this.onCargaExcel();
      this.cargando = false;
    }
  }
}
